'use client'
import Header from '@/components/header/Header'
import { useAddViewQuery, useGetAllNewsOnlyQuery, useGetNewByTranslitQuery } from '@/redux/services/newsApi'
import { newsSliderSettings } from '@/assets/data/news'
import Image from 'next/image'
import React, { useEffect, useState } from 'react'
import logoMain from '@/assets/img/dark-vers.svg'
import Footer from '@/components/Footer/Footer'
import Link from 'next/link'
import { updatedNews } from '@/assets/data/news'
import CatalogProdCard from '@/components/catalog/CatalogProdCard'
import StatsComponent from '@/components/StatsComponent'
import NewsGallerySlider from '@/components/news/NewsGallerySlider'
import NewsGalleryVideo from '@/components/news/NewsGalleryVideo'
import { useGetAllMaterialsQuery } from '@/redux/services/materialsApi'
import { getCookie } from 'cookies-next'
import { useLikeActionsMutation } from '@/redux/services/externalLinksApi'
import SliderSectionTop from '@/components/SliderSectionTop'
import { useDispatch } from 'react-redux'
import { setResetMaterialsFilters, setResetNewsFilters } from '@/redux/features/filterSlice'
import topBG from '@/assets/img/article-bg.svg'
import { useTranslation } from 'react-i18next'
import Quiz from '@/components/quiz'
import WebinarContent from './WebinarContent/WebinarContent'
import { galleryList, tags } from './mockData'
import { toggleLike } from './helpers/helpers'
import AdditionalContent from './AdditionalContent/AdditionalContent'
import Share from '@/components/Share/Share'
import VacancyContent from './VacancyContent/VacancyContent'
import Multimedia from './Multimedia/Multimedia'
import TagsContent from './TagsContent/TagsContent'
import Intro from './Intro/Intro'
import EventLinks from './EventLinks/EventLinks'
import ProductList from './ProductList/ProductList'

const ArticleDetailModule = ({
    params,
    pageType,
    fetchData,
    isEvent
}: {
    params: { id: string }
    pageType: string
    fetchData: any
    isEvent?: boolean
}) => {
    const [page, setPage] = useState(0)
    const [count, setCount] = useState(10)
    const [isLiked, setIsLiked] = useState(false)
    const [galleryOpen, setGalleryOpen] = useState(false)
    const [videoOpen, setVideoOpen] = useState(false)
    const csrf = getCookie('csrf') || ""
    const [data, setData] = useState(fetchData)
    const [submitForm, resultActionLike] = useLikeActionsMutation()
    const { t } = useTranslation()
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(setResetNewsFilters())
        dispatch(setResetMaterialsFilters())
    }, [])

    const { isFetching: isFetchingViews, data: viewAddData } = useAddViewQuery({ id: params.id })
    const { data: allMaterials } = useGetAllMaterialsQuery({
        page: page,
        count: count
    })
    const {
        data: articleData,
        refetch: refetchNew,
        isFetching
    } = useGetNewByTranslitQuery({
        id: params.id
    })

    const { data: allNews } = useGetAllNewsOnlyQuery({
        count: 10,
        page: 0
    })

    useEffect(() => {
        setData(articleData)
        const likeState = sessionStorage.getItem(`article${articleData?.id}`)

        if (likeState === 'true') {
            setIsLiked(true)
        } else {
            setIsLiked(false)
        }
    }, [articleData])

    useEffect(() => {
        refetchNew()
    }, [resultActionLike])

    const obj =
        typeof window !== 'undefined' && sessionStorage.getItem('token') !== null
            ? { token: sessionStorage.getItem('token') }
            : { token: csrf }

    return (
        <main
            className='news-details'
            itemType={
                pageType === 'news' && isEvent === false
                    ? 'https://schema.org/NewsArticle'
                    : pageType === 'usefulMaterials'
                    ? 'https://schema.org/Article'
                    : pageType === 'news' && isEvent === true
                    ? 'https://schema.org/Event'
                    : pageType === 'vacancy'
                    ? 'https://schema.org/JobPosting'
                    : pageType === 'webinar'
                    ? 'https://schema.org/Event'
                    : 'https://schema.org/Article'
            }
        >
            {pageType !== 'vacancy' && (
                <>
                    <NewsGallerySlider
                        isOpen={galleryOpen}
                        setIsOpen={state => setGalleryOpen(state)}
                        list={data?.photos ? data.photos : galleryList}
                    />
                    <NewsGalleryVideo
                        isOpen={videoOpen}
                        setIsOpen={state => setVideoOpen(state)}
                        list={data && data?.videos}
                    />
                </>
            )}
            {data ? (
                <>
                    {' '}
                    <div
                        // style={{ backgroundImage: `url('${data && data.intro}')` }}
                        className='news-details__top'
                    >
                        <Intro
                            data={data}
                            topBG={topBG}
                        />
                        <Header 
                            isWhiteLogo={true}
                            burgerBg='linear-gradient(180deg, rgba(55, 87, 166, 0) 0%, rgba(42, 58, 126, 1) 100%)'
                        />
                        <div className='news-details__top-content container'>
                            <h1
                                className='news-details__title'
                                itemProp='name'
                            >
                                {data?.title}
                            </h1>
                            <div className='news-details__top-info'>
                                <TagsContent
                                    isEvent={isEvent}
                                    data={data}
                                    pageType={pageType}
                                />
                                {!isEvent && (
                                    <StatsComponent
                                        color='#5476D4'
                                        views={data && data.views}
                                        likes={data && data.likes}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                    <div className='container'>
                        <div className='news-details__content'>
                            {data && (
                                <div className='news-details__text'>
                                    <div className='news-details__text-subtitle'>{data.subtitle}</div>
                                    <div
                                        className='news-details__text-desc'
                                        itemProp='articleBody'
                                        dangerouslySetInnerHTML={{ __html: data.description }}
                                    ></div>
                                    <meta itemProp='description' content={data.description}/>
                                    {pageType !== 'webinar' ? (
                                        <div className='news-details__content-bottom'>
                                            {!isEvent && (
                                                <StatsComponent
                                                    toggleLike={val =>
                                                        toggleLike(
                                                            val,
                                                            isFetching,
                                                            submitForm,
                                                            setIsLiked,
                                                            data,
                                                            obj,
                                                            csrf
                                                        )
                                                    }
                                                    isLiked={isLiked}
                                                    likes={data && data.likes}
                                                    views={data && data.views}
                                                />
                                            )}
                                            <Share isEvent={isEvent} />
                                        </div>
                                    ) : null}
                                </div>
                            )}
                            {data && (
                                <div className='news-details__content-side'>
                                    <VacancyContent
                                        pageType={pageType}
                                        data={data}
                                    />
                                    {isEvent && data.link && <EventLinks data={data} />}
                                    <Multimedia
                                        pageType={pageType}
                                        data={data}
                                        setGalleryOpen={setGalleryOpen}
                                        setVideoOpen={setVideoOpen}
                                    />
                                    {pageType !== 'vacancy' && <ProductList data={data} />}
                                </div>
                            )}
                        </div>
                        {pageType === 'webinar' && data ? <WebinarContent data={data} /> : null}
                        {pageType === 'webinar' && data?.quiz && data?.quiz?.id ? <Quiz webinarId={data?.id} /> : null}
                        {pageType === 'webinar' ? (
                            <div className='news-details__content-bottom'>
                                {!isEvent && (
                                    <StatsComponent
                                        toggleLike={val =>
                                            toggleLike(val, isFetching, submitForm, setIsLiked, data, obj, csrf)
                                        }
                                        isLiked={isLiked}
                                        likes={data && data.likes}
                                        views={data && data.views}
                                    />
                                )}
                                <Share isEvent={isEvent} />
                            </div>
                        ) : null}
                        {pageType === 'news' && allNews?.length && (
                            <div className='news-details__section'>
                                <SliderSectionTop
                                    title={t('otherNews')}
                                    linkText={t('readAll')}
                                />
                            </div>
                        )}
                    </div>
                    <AdditionalContent
                        pageType={pageType}
                        allNews={allNews}
                        newsSliderSettings={newsSliderSettings}
                        updatedNews={updatedNews}
                        allMaterials={allMaterials}
                    />
                </>
            ) : (
                <Header
                    isWhiteLogo={true}
                    burgerBg='linear-gradient(180deg, rgba(55, 87, 166, 0) 0%, rgba(42, 58, 126, 0.3) 100%)'
                />
            )}
            <Footer mapTheme='light' />
        </main>
    )
}

export default ArticleDetailModule
